import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Church is in the Heart',
  date: new Date(2023, 2, 5),
  img: '/img/girls.jpeg',
  tracks: [
    {
      title: 'Warmups',
      src: '/songs/2023-03-05/warmups.mp3',
    },
    {
      title: 'Roundabouts',
      src: '/songs/2023-03-05/roundabouts.mp3',
    },
    {
      title: 'Wander',
      src: '/songs/2023-03-05/wander.mp3',
    },
    {
      title: 'Flight',
      src: '/songs/2023-03-05/flight.mp3',
    },
    {
      title: 'Dialogue',
      src: '/songs/2023-03-05/dialogue.mp3',
    },
    {
      title: 'Walkabout',
      src: '/songs/2023-03-05/walkabout.mp3',
    },
    {
      title: 'Intermission',
      src: '/songs/2023-03-05/intermission.mp3',
    },
    {
      title: 'Intrigue',
      src: '/songs/2023-03-05/intrigue.mp3',
    },
    {
      title: 'Joy Ride',
      src: '/songs/2023-03-05/joy_ride.mp3',
    },
    {
      title: 'Fare Thee Well',
      src: '/songs/2023-03-05/fare_thee_well.mp3',
    },
    {
      title: 'Uptown',
      src: '/songs/2023-03-05/uptown.mp3',
    },
    {
      title: 'Room Thirteen',
      src: '/songs/2023-03-05/room_thirteen.mp3',
    },
    {
      title: 'After Hours',
      src: '/songs/2023-03-05/after_hours.mp3',
    },
  ]
}
export default album;